import React from 'react';
import '../../App.scss';
import { Form, Button, Table, Modal } from 'react-bootstrap';
import { PlusSquare } from 'react-bootstrap-icons';
import AuthorizedPage from '../../component/AuthorizedPage';
import ShipmentApi from '../../api/ShipmentApi';
import BuyerWarehouseApi from '../../api/BuyerWarehouseApi';
import WarehouseApi from '../../api/WarehouseApi';
import If from '../../component/If';
import { updateState } from '../StateHelper';
import { OrderShipmentAction, OrderShipmentActionParamsDTO } from '../../api/dto/OrderShipmentActionParamsDTO';
import { Role } from '../../domain/Role';
import { getRouteDistance } from '../../component/GoogleMapDistance'

const initialState = {
  shipments: [],
  filteredShipments: [],
  vehicles: [],
  vehicleDrivers: [],
  buyerWarehouses: [],  // Buyer warehouse listesi
  ourWarehouses: [],
  showShipmentCreateModal: false,
  showLoadWeightCheckModal: false,
  loadWeightCheckValueInTons: null,
  loadWeightCheckRelatedOrderShipmentId: null,
  showCompleted: false,
};

class ShipmentManagement extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = initialState;
    this.onSubmit = this.onSubmit.bind(this);
    this.onloadWeightCheckEntry = this.onloadWeightCheckEntry.bind(this);
    this.onLoadWeightCheckEntrySubmit = this.onLoadWeightCheckEntrySubmit.bind(this);
  }

  componentDidMount() {
    this.init();
  }

  init() {
    this.loadShipments();
    this.loadBuyerWarehouses();
    this.loadOurWarehouses();
  }

  async loadShipments() {
    let response = await ShipmentApi.listAll();
    if (response.success) {
      const shipments = response.data || [];
      console.log("loadShipments: toplam sevkiyat:", shipments.length);

      // tüm sevkiyatları state'e koy
      updateState(this, "shipments", shipments);

      // showCompleted flag'ine göre filteredShipments'u setle
      if (this.state.showCompleted) {
        console.log("loadShipments -> showCompleted true: hepsi gösteriliyor");
        updateState(this, "filteredShipments", shipments);
      } else {
        const filtered = shipments.filter(
          (s: any) => s.statusDetail?.name !== "DELIVERY_COMPLETED"
        );
        console.log("loadShipments -> showCompleted false: filtreli gösterim", filtered.length);
        updateState(this, "filteredShipments", filtered);
      }

      // garanti olarak showCompleted default değerini tekrar setle (opsiyonel)
      updateState(this, "showCompleted", this.state.showCompleted ?? false);
    }
  }


  async loadBuyerWarehouses() {
    let response = await BuyerWarehouseApi.listAllBuyerWarehouses();
    if (response.success) {
      updateState(this, "buyerWarehouses", response.data);
    }
  }

  async loadOurWarehouses() {
    let response = await WarehouseApi.listAllWarehouses();
    if (response.success) {
      updateState(this, "ourWarehouses", response.data);
    }
  }

  async loadAvailableVehicles() {
    let response = await ShipmentApi.listAvailableVehicles();
    if (response.success) {
      updateState(this, "vehicles", response.data);
    }
  }

  async loadAvailableVehicleDrivers() {
    let response = await ShipmentApi.listDrivers();
    if (response.success) {
      updateState(this, "vehicleDrivers", response.data);
    }
  }

  async onCheckContents(orderShipmentId: Number) {
    window.location.assign("/sevkiyat-siparis-yonetimi?orderShipmentId=" + orderShipmentId);
  }

  async onShipmentLoading(orderShipmentId: Number) {
    await ShipmentApi.markAsLoading(orderShipmentId);
    this.refresh();
  }

  async onShipmentCompleted(orderShipmentId: Number) {
    await ShipmentApi.markAsCompleted(orderShipmentId);
    this.refresh();
  }

  async onloadWeightCheckEntry(orderShipmentId: Number) {
    console.log("triggered");
    updateState(this, "showLoadWeightCheckModal", true);
    updateState(this, "loadWeightCheckRelatedOrderShipmentId", orderShipmentId);
  }

  async onLoadWeightCheckEntrySubmit(e: any) {
    e.preventDefault();
    const shipmentId = e.target.loadWeightCheckRelatedOrderShipmentId.value;
    const weightInTons = e.target.loadWeightCheckValueInTons.value;
    console.log("Submitting weight check:", { shipmentId, weightInTons });

    if (!shipmentId || !weightInTons) {
      alert("Lütfen ağırlık giriniz!");
      return;
    }

    let body = new OrderShipmentActionParamsDTO(
      OrderShipmentAction[OrderShipmentAction.COMPLETE_LOAD_WEIGHT_CHECK],
      weightInTons
    );

    await ShipmentApi.onAction(shipmentId, body);
    this.refresh();
    updateState(this, "showLoadWeightCheckModal", false); // modal kapatma
  }


  async onAction(orderShipmentId: Number, action: OrderShipmentAction, params?: any) {
    console.log("⚡ onAction çağrıldı:", { orderShipmentId, action, params });

    let body = new OrderShipmentActionParamsDTO(OrderShipmentAction[action]);
    console.log("📦 Gönderilen body:", body);

    try {
      let response = await ShipmentApi.onAction(orderShipmentId, body);
      console.log("✅ onAction API cevabı:", response);
    } catch (err) {
      console.error("❌ onAction API hatası:", err);
    }

    this.refresh();
  }


  onCreateNewShipment = () => {
    this.loadAvailableVehicles();
    this.loadAvailableVehicleDrivers();
    updateState(this, "showShipmentCreateModal", true);
  }

  onSwitchChange = (e: any) => {
    const checked = e.target.checked; // true → hepsi, false → sadece aktifler

    updateState(this, "showCompleted", checked);

    if (!checked) {
      // Switch kapalı → sadece tamamlanmamış sevkiyatlar
      const filtered = this.state.shipments.filter(
        (s: any) => s.statusDetail?.name !== "DELIVERY_COMPLETED"
      );
      updateState(this, "filteredShipments", filtered);
    } else {
      // Switch açık → hepsi
      updateState(this, "filteredShipments", this.state.shipments);
    }
  };

  async onSubmit(e: any) {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formObject: any = Object.fromEntries(formData);

    const fromWarehouse = this.state.ourWarehouses.find((w: any) => w.id === Number(formObject.fromWarehouseId));
    console.log("fromWarehouse:", fromWarehouse);
    const toWarehouse = this.state.buyerWarehouses.find((w: any) => w.id === Number(formObject.toWarehouseId));
    console.log("toWarehouse:", toWarehouse);
    const intermediateStop1 = this.state.buyerWarehouses.find((w: any) => w.id === Number(formObject.intermediateWarehouse1Id));
    const intermediateStop2 = this.state.buyerWarehouses.find((w: any) => w.id === Number(formObject.intermediateWarehouse2Id));

    if (fromWarehouse) {
      formObject.fromWarehouseLongitude = fromWarehouse.longitude;
      formObject.fromWarehouseLatitude = fromWarehouse.latitude;
    }
    if (toWarehouse) {
      formObject.toWarehouseLongitude = toWarehouse.longitude;
      formObject.toWarehouseLatitude = toWarehouse.latitude;
    }

    if (intermediateStop1) {
      formObject.intermediateWarehouseLongitude1 = intermediateStop1.longitude;
      formObject.intermediateWarehouseLatitude1 = intermediateStop1.latitude;
    }
    if (intermediateStop2) {
      formObject.intermediateWarehouseLongitude2 = intermediateStop2.longitude;
      formObject.intermediateWarehouseLatitude2 = intermediateStop2.latitude;
    }

    let response = await ShipmentApi.createOrUpdate(formObject);
    if (response.success) {
      e.target.reset();
      this.refresh();
      updateState(this, "showShipmentCreateModal", false);
    } else {
      alert("Sevkiyat oluşturulurken hata oluştu.");
    }
  }

  onModalClose() {
    updateState(this, "showShipmentCreateModal", false);
  }

  // Yardımcı fonksiyon: ID’den isim bulma
  findWarehouseTitleById(id: number, list: any[]) {
    const found = list.find(w => w.id === id);
    return found ? found.title : "";
  }

  renderLoadWeightCheckModal = () => {
    const { showLoadWeightCheckModal, loadWeightCheckRelatedOrderShipmentId } = this.state;

    return (
      <Modal show={showLoadWeightCheckModal} onHide={() => updateState(this, "showLoadWeightCheckModal", false)} dialogClassName="modal-50w">
        <Modal.Header closeButton>
          <Modal.Title>Kantardan İndir</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={this.onLoadWeightCheckEntrySubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Yüklenen Ağırlık (Ton)</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="loadWeightCheckValueInTons"
                placeholder="Ağırlığı giriniz"
                required
              />
            </Form.Group>
            <Form.Control
              type="hidden"
              name="loadWeightCheckRelatedOrderShipmentId"
              value={this.state.loadWeightCheckRelatedOrderShipmentId || ''}
            />
            <Button type="submit">Kaydet</Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  renderShipments = () => {
    const { buyerWarehouses, ourWarehouses } = this.state;
    return (
      <div style={{ marginTop: "15px" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Sevkiyat Kodu</th>
              <th>Araç</th>
              <th>Güzergah</th>
              <th>Yüklenen Koli</th>
              <th>Yükleme Bilgisi (Ton)</th>
              <th>Mesafe (km)</th>
              <th>Süre</th>
              <th>Durumu</th>
              <th>Aksiyon</th>
            </tr>
          </thead>
          <tbody>
            {this.state.filteredShipments && this.state.filteredShipments.map((it: any) => {
                console.log("StatusDetail:", it.statusDetail);
                console.log("StatusDetail.name:", it.statusDetail?.name);
                console.log("totalItemCount:", it.totalItemCount);
              // ID’ler geldiği varsayılarak, isimleri buluyoruz
              const fromWarehouseName = ourWarehouses.find((w: any) => w.id === it.fromWarehouseId)?.name || "";
              const toWarehouseName = buyerWarehouses.find((w: any) => w.id === it.toWarehouseId)
                ? `${buyerWarehouses.find((w: any) => w.id === it.toWarehouseId)?.buyerTitle} - ${buyerWarehouses.find((w: any) => w.id === it.toWarehouseId)?.title}`
                : "";

              const intermediateWarehouseName1 = it.intermediateWarehouse1Id
                ? `${buyerWarehouses.find((w: any) => w.id === it.intermediateWarehouse1Id)?.buyerTitle} - ${buyerWarehouses.find((w: any) => w.id === it.intermediateWarehouse1Id)?.title}`
                : "";

              const intermediateWarehouseName2 = it.intermediateWarehouse2Id
                ? `${buyerWarehouses.find((w: any) => w.id === it.intermediateWarehouse2Id)?.buyerTitle} - ${buyerWarehouses.find((w: any) => w.id === it.intermediateWarehouse2Id)?.title}`
                : "";


              // Mesafe (metreden km'ye)
              const distanceKm = it.routeDistance ? (it.routeDistance / 1000).toFixed(2) : "-";

              // Süre: duration verisi saniye cinsindense dakika olarak gösterelim
              const durationMinutes = it.duration ? Math.round(it.duration / 60) + " dk" : "-";

              return (
                <tr key={it.id + it.shipmentCode}>
                  <td>{it.shipmentCode}</td>
                  <td>{it.vehicleDescription}</td>
                  <td>
                    {fromWarehouseName}
                    {intermediateWarehouseName1 && intermediateWarehouseName1.trim() !== "" && <> → {intermediateWarehouseName1}</>}
                    {intermediateWarehouseName2 && intermediateWarehouseName2.trim() !== "" && <> → {intermediateWarehouseName2}</>}
                    {" → "}
                    {toWarehouseName}
                  </td>
                  <td>
                    <span onClick={() => this.onCheckContents(it.id)}>
                      <Button variant="link" className="btn-sm">{it.totalItemCount}</Button>
                    </span>
                  </td>
                  <td>
                    Beklenen : {it.expectedWeightInTons} |
                    Ölçülen  : {it.loadedWeightInTons}
                  </td>
                  <td>{distanceKm}</td>
                  <td>{durationMinutes}</td>
                  <td>{it.statusDetail.label}</td>
                  <td className="col-auto">
                    <div className="btn-group-vertical">
                      {/* Aksiyon butonları */}
                      <If value={"LOAD_CHECK" === it.statusDetail.name && it.totalItemCount > 0 && false}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onCheckContents(it.id)}>
                          <Button variant="primary" className="btn-sm">İçeriği Kontrol Et</Button>
                        </span>
                      </If>
                      <If value={"PARKING" === it.statusDetail.name}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.PREPARE_TO_LOAD)}>
                          <Button variant="warning" className="btn-sm">Sevkiyat İçin Hazırla</Button>
                        </span>
                      </If>
                      <If value={"PREPARING_TO_LOAD" === it.statusDetail.name}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOADING)}>
                          <Button variant="primary" className="btn-sm">Yüklemeyi Başlat</Button>
                        </span>
                      </If>
                      <If value={"LOADING" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOAD_CHECK)}>
                          <Button variant="primary" className="btn-sm">Yükleme Kontrolüne Başla</Button>
                        </span>
                      </If>
                      <If value={"LOADING" === it.statusDetail.name}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.PREPARE_TO_LOAD)}>
                          <Button variant="warning" className="btn-sm">Yüklemeyi Durdur</Button>
                        </span>
                      </If>
                      <If value={"LOAD_CHECK" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.COMPLETE_LOAD_CHECK)}>
                          <Button variant="primary" className="btn-sm">Yükleme Kontrolünü Bitir</Button>
                        </span>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOADING)}>
                          <Button variant="warning" className="btn-sm">Yüklemeye Devam Ettir</Button>
                        </span>
                      </If>
                      <If value={"LOAD_CHECK_COMPLETED" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOAD_WEIGHT_CHECK)}>
                          <Button variant="primary" className="btn-sm">Kantara Çıkar</Button>
                        </span>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOAD_CHECK)}>
                          <Button variant="warning" className="btn-sm">Yüklemeyi Tekrar Kontrol Et</Button>
                        </span>
                      </If>
                      <If value={"LOAD_WEIGHT_CHECK" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onloadWeightCheckEntry(it.id)}>
                          <Button variant="primary" className="btn-sm">Kantardan İndir</Button>
                        </span>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOAD_CHECK)}>
                          <Button variant="warning" className="btn-sm">Yüklemeyi Tekrar Kontrol Et</Button>
                        </span>
                      </If>
                      <If value={"LOAD_WEIGHT_CHECK_COMPLETED" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_DELIVERY)}>
                          <Button variant="danger" className="btn-sm">Sevkiyatı Yola Çıkar</Button>
                        </span>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.START_LOAD_CHECK)}>
                          <Button variant="warning" className="btn-sm">Yüklemeyi Tekrar Kontrol Et</Button>
                        </span>
                      </If>
                      <If value={"ON_DELIVERY" === it.statusDetail.name && it.totalItemCount > 0}>
                        <span className="col-sm" style={{ marginBottom: "3px" }} onClick={() => this.onAction(it.id, OrderShipmentAction.SET_AS_DELIVERY_COMPLETED)}>
                          <Button variant="danger" className="btn-sm">Sevkiyat Teslim Edildiyse Bitir</Button>
                        </span>
                      </If>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  renderDropdownOptions = (items: any) => {
    return items.map((it: any) => {
      return <option key={it.id} value={it.id}>{it.buyerTitle} - {it.title}</option>;
    });
  };

  renderShipmentCreateModal = () => {
    const { vehicles, vehicleDrivers, buyerWarehouses, ourWarehouses } = this.state;

    const vehicleOptions = vehicles && vehicles.map((it: any) => {
      return { key: it.id, value: it.licencePlateCode + " " + it.brand + "-" + it.model };
    });

    const vehicleDriverOptions = vehicleDrivers && vehicleDrivers.map((it: any) => {
      return { key: it.id, value: it.name + " " + it.surname };
    });

    let vehicleOptionsDOM = vehicleOptions.map((v: any) => <option key={v.key} value={v.key}>{v.value}</option>);
    let vehicleDriverOptionsDOM = vehicleDriverOptions.map((d: any) => <option key={d.key} value={d.key}>{d.value}</option>);
    let buyerWarehouseOptionsDOM = buyerWarehouses.map((w: any) => (
      <option key={w.id} value={w.id}>{w.buyerTitle} - {w.title}</option>
    ));
    const ourWarehouseOptionsDOM = ourWarehouses.map((w: any) => (
      <option key={w.id} value={w.id}>
        {w.name}
      </option>
    ));

    return (
      <Modal autoFocus={true} show={this.state.showShipmentCreateModal} onHide={() => this.onModalClose()} dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>Sevkiyat Oluştur</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form onSubmit={this.onSubmit}>

            <Form.Group className="mb-3">
              <Form.Label>Araç</Form.Label>
              <Form.Select name="vehicleId" required>
                <option value="">Seçiniz</option>
                {vehicleOptionsDOM}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Sürücü</Form.Label>
              <Form.Select name="driverId" required>
                <option value="">Seçiniz</option>
                {vehicleDriverOptionsDOM}
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Açıklama</Form.Label>
              <Form.Control as="textarea" rows={2} name="description" placeholder="Açıklama giriniz" />
            </Form.Group>

            <Button variant="primary" type="submit">
              Kaydet
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    );
  };

  refresh = () => {
    this.loadShipments();
  }

  render() {
    return (
      <AuthorizedPage role={Role.BACKOFFICE_ADMIN}>
        <div className="centered-95-percent zero-div">
          <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
            <h4>Sevkiyat Yönetimi</h4>
            <Button variant="success" onClick={this.onCreateNewShipment}>
              <PlusSquare /> Yeni Sevkiyat
            </Button>
          </div>
          <div className="d-flex justify-content-start align-items-center mb-2">
            <Form.Check
              type="switch"
              id="completed-switch"
              label="Tamamlananları Göster"
              checked={this.state.showCompleted}
              onChange={this.onSwitchChange}
            />
          </div>
          {this.renderShipments()}
          {this.renderShipmentCreateModal()}
          {this.renderLoadWeightCheckModal()}
        </div>
      </AuthorizedPage>
    );
  }
}

export default ShipmentManagement;
